var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup137(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 6 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    transform: "translate(-1806.883 -328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_136"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    d: "M13.922,8.14H9.1V3.321A1.071,1.071,0,0,0,8.032,2.25H6.961A1.071,1.071,0,0,0,5.89,3.321V8.14H1.071A1.071,1.071,0,0,0,0,9.211v1.071a1.071,1.071,0,0,0,1.071,1.071H5.89v4.819a1.071,1.071,0,0,0,1.071,1.071H8.032A1.071,1.071,0,0,0,9.1,16.172V11.353h4.819a1.071,1.071,0,0,0,1.071-1.071V9.211A1.071,1.071,0,0,0,13.922,8.14Z",
    transform: "translate(1814.387 332.921)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup137);
export default __webpack_public_path__ + "static/media/Group 137.928cb851f4a83fae63cfd105426b7e4e.svg";
export { ForwardRef as ReactComponent };